import { render } from "./accountStatement.vue?vue&type=template&id=067f9805&scoped=true"
import script from "./accountStatement.vue?vue&type=script&lang=js"
export * from "./accountStatement.vue?vue&type=script&lang=js"

import "./accountStatement.vue?vue&type=style&index=0&id=067f9805&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067f9805"]])

export default __exports__